<div class="cart-preview-card animated fadeInRight">

  @if (!isJustAddedProductNotification()) {
  <header class="d-flex justify-content-end">
    <span class="cart-preview-card__tag"
      [ngClass]="{'preview-tag-success': isInOrder(), 'preview-tag-warning': !isInOrder()}">
      {{isInOrder() ? 'In your order' : 'Not yet saved'}}
    </span>
  </header>
  }

  <section class="d-flex justify-content-between align-items-center gap-3">

    <div class="cart-preview-card__img">
      <a [routerLink]="['/shop/'+(product()?.productUrl || '')]">
        <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image"
          (error)="handleImageError($event)" />
      </a>
    </div>

    <div class="d-flex flex-column justify-content-center flex-grow-1 width-100 gap-2">

      <!-- Name -->
      <a class="title" [routerLink]="['/shop/'+(product()?.productUrl || '')]">
        {{ product().name }}
      </a>

      <div class="d-flex justify-content-between align-items-center">

        <div class="cart-preview-card__content">

          <!-- Display -->
          <span class="subtitle">
            @if (product()?.variant?.attribute?.name) {
            {{product()?.variant?.attribute?.name}}: {{product()?.variant?.attribute?.value?.name}}
            } @else if (product()?.package) {
            Package: {{ product()?.package?.name }}
            }

            @if (product()?.subscription) {
            {{((product()?.package?.name || product()?.variant?.attribute?.name) ? ' | ' : '') +
            product().subscription?.frequency?.name}}
            }
          </span>

          <!-- Price -->
          @if (!product().bundle?.items?.length && product().bundle?.priceRange) {
          <span class="price">
            {{ product().bundle.priceRange }}
          </span>
          } @else {
          <span class="price">
            {{ productTotalPrice() | currency}}
            @if (productOriginalTotalPrice() && productOriginalTotalPrice() !== productTotalPrice()) {
            <span class="original-price">
              {{ productOriginalTotalPrice() | currency}}
            </span>
            }
          </span>
          }

        </div>

        @if (!isJustAddedProductNotification()) {
        @let isPreOrder = product().isPreOrder;
        <div class="d-flex flex-column gap-2">
          <div class="input-plus-minus">

            <button type="button" class="btn-plusminus" (click)="handleMinus()" ngbTooltip="Remove Quantity"
              placement="bottom" tooltipClass="tooltip-sm" [disabled]="newQuantity() <= 1 || (isPreOrder && newQuantity() <= (product().quantity || 1))">
              -
            </button>

            <mat-form-field class="d-flex" subscriptSizing="dynamic">
              <input type="text" matInput appNumberRestriction [minNumber]="1" [maxNumber]="100"
                (keyup)="onKeyUp($event)" (keyup.enter)="updateQuantity()" (blur)="updateQuantity()"
                [value]="newQuantity()" [disabled]="isPreOrder">
            </mat-form-field>

            <!-- DEV-11172: pre-order lines can be increased, so "+" stays enabled. -->
            <button type="button" class="btn-plusminus" (click)="handlePlus()" ngbTooltip="Add Quantity"
              placement="bottom" tooltipClass="tooltip-sm">
              +
            </button>

          </div>

          @if (!isPreOrder) {
          <span class="cart-preview-card__delete link-color" (click)="removeCartProduct()"
            [class.disabled]="isDeletingProduct()">
            {{ product().isDeleting ? 'Deleting...': 'Delete'}}
          </span>
          }
        </div>
        }

      </div>

    </div>

  </section>

  @if (product()?.bundle && product()?.bundle?.items?.length && !isJustAddedProductNotification()) {

  <a class="text-start cart-preview-card__delete link-color" data-bs-toggle="collapse"
    [attr.data-bs-target]="'#collapse_'+product().id" aria-expanded="false"
    [attr.aria-controls]="'collapse_'+product().id">
    What's inside
  </a>

  <div class="collapse bg-primary bg-opacity-10 pt-2 rounded-4" [id]="'collapse_'+product().id">
    @for (item of product().bundle.items; track $index) {
    <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
      <div class="col-8">
        <h6 class="h8-semibold">{{ item.name }} {{item.packageName ? (' | ' +
          item.packageName) : (item.display ? (' | ' + item.display) : '')}}</h6>
        @if (item?.presentation) {
        <small class="h7-semibold">
          {{ item.presentation.quantity }}
          {{ item.presentation.type }}
        </small>
        }
      </div>
      <div class="col-4">
        <h6 class="h8-semibold text-end">{{item.quantity}}</h6>
      </div>
    </div>
    }
  </div>

  @if(!product().bundle.isLocked) {
  <button type="button" class="btn btn-outline-secondary h6-bold head-font mt-2" (click)="goToCustomizeBox()">
    Customize Box
  </button>
  }

  }

  @if (product().isPreOrder) {
  <!-- DEV-11172: compact "Pre-Order" badge instead of a full-width notice.
       Info icon signals the tooltip; tooltip explains pre-order items can't
       be removed and qty can only go up. -->
  <span class="badge bg-secondary cursor-pointer d-inline-flex align-items-center gap-1"
    [triggers]="isMobile() ? 'click' : 'hover focus'"
    [autoClose]="true"
    tabindex="0"
    role="button"
    ngbTooltip="This is a pre-order item. It can't be removed from the order, and the quantity can only be increased. Contact customer service for any other change."
    container="body">
    Pre-Order
    <i class="material-symbols-outlined" style="font-size: 0.9rem;">info</i>
  </span>
  }
</div>